/**
 * AI Trigger Process Types
 *
 * Identifies which business process triggered an AI generation.
 * Used for cost allocation and analytics grouping.
 *
 * NOTE: This enum will grow as AI is integrated into more processes.
 */
export var AiTriggerProcessType;
(function (AiTriggerProcessType) {
    /** AI triggered during transaction processing (e.g., dynamic token image/description) */
    AiTriggerProcessType["TRANSACTION"] = "TRANSACTION";
})(AiTriggerProcessType || (AiTriggerProcessType = {}));
//# sourceMappingURL=ai-trigger-process-type.enum.js.map